import { Box, Button } from '@mui/material';
import Countdown from 'react-countdown';
import ReactPlayer from 'react-player'

// Dragon card
export default //
    function RevealMovie(props: any) {
    return (
        <Box sx={{
            backgroundColor: "#101010dd",
            width: "100%",
            position: "fixed",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <ReactPlayer
                className="reveal-video-cont"
                url="https://vimeo.com/725613122"
                loop={false}
                muted={true}
                playing={true}
                playsinline={true}
                autoPlay={true}
                preload={"auto"}
                controls={true}
                onEnded={props.onRevealMovieEnded}
                style={{ display: "block", borderRadius: "20px" }} />

            <Button onClick={props.skipRevealMovie}
                sx={{
                    position: "fixed",
                    bottom: 0,
                    right: 0,
                    margin: "10px",
                    background: "#ffe8c8",
                    color: "#222222",
                    fontWeight: 700,
                    fontSize: "13px"
                }} variant="contained">skip</Button>
        </Box>)
}